import { Component, OnInit } from '@angular/core';
import { UserMgmtService } from '../user.service';

@Component({
  selector: 'app-user-dashboard',
  templateUrl: './user-dashboard.component.html',
  styleUrls: ['./user-dashboard.component.css']
})
export class UserDashboardComponent implements OnInit {
  showUserData: boolean =true
  isLoading: boolean=false;
  userData:any;
  stateList:any;
  //type of charts
	lineChart= 'LineChart';
	pieChart = 'PieChart';
	BarChart = 'BarChart';
	colorScheme = {
		domain: ["#5AA454", "#A10A28", "#C7B42C", "#AAAAAA"]
	  };
  constructor( private userService: UserMgmtService) { }

  ngOnInit() {
   this.getUserStatus();
   this.getUserRole();
   this.getRecentLogin();
   this.getMontlyUser();
   this.RsoStatus();


  }
  UserStatusData : any;
  getUserStatus() {
    this.isLoading = true;
    this.userService.getUserByStatus().subscribe(res => {
      this.isLoading = false;
      if ((res["message"] = "Success")) {
        this.UserStatusData = res["data"];
        // console.log(this.userList)
      } else {
      }
      this.isLoading = false;
    },
    err => {
      this.isLoading = false;
    });
  }
  UserRoleData : any;
  getUserRole() {
    this.isLoading = true;
    this.userService.getUserByRole().subscribe(res => {
      this.isLoading = false;
      if ((res["message"] = "Success")) {
        this.UserRoleData = res["data"];
        // console.log(this.userList)
      } else {
      }
      this.isLoading = false;
    },
    err => {
      this.isLoading = false;
    });
  }
 
  RsoStatusdata:any
  RsoStatus() {
    this.isLoading = true;
    this.userService.getRsoByStatus().subscribe(res => {
      this.isLoading = false;
      if ((res["message"] = "Success")) {
        this.RsoStatusdata = res["data"];
        // console.log(this.userList)
      } else {
      }
      this.isLoading = false;
    },
    err => {
      this.isLoading = false;
    });
  }
   lastLoginData:any
  getRecentLogin() {
    this.isLoading = true;
    this.userService.getRecentLoginUser().subscribe(res => {
      this.isLoading = false;
      if ((res["message"] = "Success")) {
        this.lastLoginData = res["data"];
        // console.log(this.userList)
      } else {
      }
      this.isLoading = false;
    },
    err => {
      this.isLoading = false;
    });
  }

  montlyUserData:any
  montlyUserDataOption:any;
  montlyUserDataColumn:any;
  montlyUserDataInit() {
	this.montlyUserDataOption = {
		colors: ['#ed5559'],
		hAxis: {
		   title: 'Date',
		  
		},
		vAxis:{
		   title: 'Total Users',
		},
		animation: {
			duration: 5000,
			easing: 'out',
			startup: true
		},
	};
	this.montlyUserDataColumn = ["Total Count","Date"];
}
  getMontlyUser() {
    this.isLoading = true;
    this.userService.getmonthlyUsersCount().subscribe(res => {
      this.isLoading = false;
      if ((res["message"] = "Success")) {
		this.montlyUserData = res['0']['series'];
		this.montlyUserDataInit();
		console.log(this.montlyUserData)
        // console.log(this.userList)
      } else {
      }
      this.isLoading = false;
    },
    err => {
      this.isLoading = false;
    });
  }


 
}

